import {useEffect} from 'react'
import {useDispatch,useSelector} from 'react-redux'
import Form from 'react-bootstrap/Form'
import LocaleDate from '../../LocaleDate/LocaleDate'
import {useMemo,useState} from 'react'
import useCurrentUser from '../../../hooks/useCurrentUser'
import {dateToAPIStandard} from '../../../util/util'
import useApiStatusDispatch from '../../../hooks/useApiStatusDispatch'
import {
	markSessionComplete,
	markSessionIncomplete,
	addSessions,
	editSession
} from './sessionsSlice'
import DatePicker from 'react-datepicker'

const Session = ({session,showName=true})=>{
	const user = useCurrentUser()
	const isClient = user.account_type === 'client'
	const statusDispatch = useApiStatusDispatch()
	const [completed,setCompleted] = useState(Boolean(session.is_completed))
	const toggleComplete = () => {
		setCompleted(!completed)
		if(!completed){
			statusDispatch(markSessionComplete(session),'session','edit')
		}else{
			statusDispatch(markSessionIncomplete(session),'session','edit')
		}
	}
	const handleCompletedDate = newCompletedDate => {
		statusDispatch(editSession({
			id:session.session_id,
			update:{
				completed_on:dateToAPIStandard(newCompletedDate)
			}
		}),'session','edit')
	}
	const [showAddSessionModal,setShowAddSessionModal] = useState(false)
	return (
		<div style={{
			borderBottom:'1px solid #ccc',
			display:'flex',
			alignItems:'center',
			padding:'4px 8px'
		}}>
			<span style={{width:'140px'}}>
				<LocaleDate 
					date={new Date(session.date_purchased.split(' ').join('T'))}
					includeTime={false}
				/>
			</span>
			{showName&&
				<>
					<span className="text-muted mx-2">|</span>
					{!isClient&&session.client_user_name}
				</>
			}
			<div className="ml-auto d-flex flex-column align-items-end">
				<div className="d-flex align-items-center">
					<small className="mr-2">
						{
							completed
							? <span className="text-success">Complete</span>
							: <span className="text-danger">Incomplete</span>
						}
					</small>
					{(!isClient||!completed)&&
						<Form.Switch 
							id={`sesson-complete-switch-${session.session_id}`}
							onChange={toggleComplete}
							checked={completed}
						/>	
					}
				</div>
				<small className="text-right">
					{(session.completed_by_user_name && session.is_completed === 1) 
						? <span>completed by: <span className="text-info">{session.completed_by_user_name}</span></span>
						: null
					}
					{(session.is_completed === 1)&&
						<>
							<span className="mx-1">on</span>
							<span className="text-info">
								{isClient?
									(Boolean(session.completed_on)&&<LocaleDate 
										date={new Date(session.completed_on.split(' ').join('T'))}
									/>)
									:
									<DatePicker 
										onChange={handleCompletedDate}
										popperModifiers={{preventOverflow: {enabled: true,},}}
										className="text-center"
										selected={
											Boolean(session.completed_on)
											? new Date(session.completed_on.split(' ').join('T'))
											: null
										}
									/>
								}
							</span>
						</>
					}
				</small>
			</div>
		</div>
	)
}

export default Session